var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"noWrap"},[_vm._v("\n  "+_vm._s(_vm.props.value || '0')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }